import * as schema from "./generated/schema";
import { request } from "@/api";
type PayrollEntriesPath = schema.paths["/api/payroll_entries"];
type PayrollEntriesResponse =
  PayrollEntriesPath["get"]["responses"]["200"]["content"]["application/json"];
export type PayrollEntry = PayrollEntriesResponse["items"][number];

export const getPayrollEntries = async (page: number, page_size: number) => {
  return await request.get<PayrollEntriesResponse>({
    page_size,
    page,
    pagination: true,
    url: "/api/payroll_entries",
  });
};
